<script setup>
const { commit } = useStore();

const props = defineProps({
   notification: {
      type: Object,
      default: null,
   },
});

const timeout = ref(null);

const type_class = computed(() => {
   return `-${props.notification?.type}`;
});

onBeforeUnmount(() => {
   if (timeout.value) clearTimeout(timeout.value);
});
onMounted(() => {
   if (props.notification?.duration !== Infinity) {
      setRemoveTimer();
   }
});

function setRemoveTimer() {
   timeout.value = setTimeout(() => {
      commit('removeNotification', props.notification);
   }, props.notification?.duration);
}

//#region Action
function handleAction() {
   if (props.notification.action) props.notification.action();

   commit('removeNotification', props.notification);
}
//#endregion
</script>

<template>
   <div class="notification" :class="type_class">
      <div class="notification__wrapper">
         <NxtSpinner v-if="notification?.spinner" class="notification__spinner" :size="'small'" />
         <span :class="['notification__text', { '-has-spinner': notification?.spinner }]">
            {{ notification?.message }}
         </span>
      </div>
      <div v-if="notification.action && notification.actionText" class="nxt-notification__main__action">
         <NxtLink @on-click="handleAction">
            <span>{{ notification.actionText }}</span>
         </NxtLink>
      </div>
   </div>
</template>

<style lang="scss" scoped>
.notification {
   position: relative;

   background: var(--surface-container-1);
   padding: var(--nxt-gutter);
   min-width: toRem(240);
   max-width: toRem(400);
   border-radius: toRem(4);
   margin-top: 0.6rem;

   box-shadow: 0px 1px toRem(4) 0px rgba(0, 0, 0, 0.3);

   &.-success {
      border-left: toRem(5) solid var(--nxt-brand-primary);
   }
   &.-error {
      border-left: toRem(5) solid var(--stroke-error);
   }
   &.-info {
      border-left: toRem(5) solid var(--nxt-brand-primary);
   }
}
.notification__wrapper {
   display: flex;
   flex-direction: row;
   align-items: center;
}
.notification__spinner {
   height: 2rem;
}
.notification__text {
   &.-has-spinner {
      padding-left: toRem(12);
   }
}
</style>
